<template>
<div class="chapter">
<div class="inner_page">
<p class="IVPh1" id="toc">Hearing God</p>
<p class="IVPh3">Developing a Conversational Relationship with God</p>
<p class="IVPh3">Updated &amp; Expanded by Jan Johnson</p>
<p class="IVPh3">Dallas Willard</p>
<p class="first"> </p>
<p class="IVPcenter"><img alt="IVP Books Imprint" src="Images/IVP_Books_Quarter.jpg"/></p>
<p class="IVPcenter"><a href="http://www.IVPress.com/books/" target="_blank">www.IVPress.com/books</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?0b7dcbec